import React from "react";
import styles from "./FormMessages.module.css";

interface FormMessagesProps {
  error?: string;
  success?: string;
}

export const FormMessages: React.FC<FormMessagesProps> = ({
  error,
  success,
}) => {
  if (!error && !success) return null;

  return (
    <>
      {error && <div className={styles.error}>{error}</div>}
      {success && <div className={styles.success}>{success}</div>}
    </>
  );
};
